import React, { useState, useContext, useEffect } from "react";
import FirebaseOrder from "./FirebaseOrder";
import { getAuth } from "firebase/auth";
import {fs} from '../../firebase'
import { getFirestore,doc,getDoc } from 'firebase/firestore';
import { LocalizationContext } from '../../localization/LocalizationContext';
import { getUserPhoneNumber } from '../../utils/userUtils';
import { API_PROXY_BASE } from '../../config/api';
const AddSelfTake = ({ totalPrice, selectedProducts, productQuantities }) => {
    const { translations } = useContext(LocalizationContext);
    const [pickup, setPickup] = useState({ lat: 55.751244, lng: 37.618423, address: "" });
    const [destination, setDestination] = useState({ lat: 55.751244, lng: 37.618423, address: "" });
    const [recipientName, setRecipientName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [selectedOrgId, setSelectedOrgId] = useState("");
    const [organizations, setOrganizations] = useState([]);
    const [token, setToken] = useState('');
    const orderReceipt = 'self-pickup'
    const [deliveryDateTime, setDeliveryDateTime] = useState('');
    // Handler for the destination address input
    const handleDestinationChange = (e) => {
        setDestination({ ...destination, address: e.target.value });
    };
    const [deliveryTimeOption, setDeliveryTimeOption] = useState('asap');


    const handleOptionChange = (e) => {
        setDeliveryTimeOption(e.target.value);
    };

    const handleDateTimeChange = (e) => {
        setDeliveryDateTime(e.target.value);
    };
    const [personsCount, setPersonsCount] = useState(1);
    const [comment, setComment] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('online');

    const handlePersonsChange = (delta) => {
        setPersonsCount(prev => Math.max(1, prev + delta));
    };

    const handlePaymentChange = (e) => {
        setPaymentMethod(e.target.value);
    };

    useEffect(() => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            setRecipientName(user.displayName || '');

            const fs = getFirestore();
            const userDocRef = doc(fs, "users", user.uid);

            getDoc(userDocRef)
                .then((docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        console.log('User data:', userData);
                        setPhoneNumber(getUserPhoneNumber(userData) || '');
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user document:", error);
                });
        }
    }, []);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const res = await fetch(`${API_PROXY_BASE}/access_token`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });

                const data = await res.json();
                if (data?.token) {
                    setToken(data.token);
                } else if (data?.correlationId) {
                    setToken(data.correlationId);
                } else {
                    throw new Error('Токен не получен');
                }
            } catch (err) {
                console.error('Ошибка при получении токена:', err);
            }
        };

        fetchToken();
    }, []);

    useEffect(() => {
        if (!token) return;

        const fetchOrganizations = async () => {
            try {
                const res = await fetch(`${API_PROXY_BASE}/organizations`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        organizationIds: [],
                        returnAdditionsInfo: true,
                        includeDisabled: false
                    })
                });

                const data = await res.json();

                if (Array.isArray(data.organizations)) {
                    setOrganizations(data.organizations);
                } else {
                    console.error("Неверный формат данных организаций:", data);
                }
            } catch (err) {
                console.error('Ошибка при получении организаций:', err);
            }
        };

        fetchOrganizations();
    }, [token]);

    useEffect(() => {
        if (organizations.length === 0 || !selectedProducts) return;

        const allProducts = Array.isArray(selectedProducts)
            ? selectedProducts
            : Object.values(selectedProducts).flat();

        if (allProducts.length === 0) return;

        const uniqueOrgIds = [...new Set(allProducts.map(p => p.organizationId).filter(Boolean))];

        if (uniqueOrgIds.length === 1 && uniqueOrgIds[0]) {
            setSelectedOrgId(uniqueOrgIds[0]);
        }
    }, [organizations, selectedProducts]);

    return (
        <div className="add-delivery-container">

            <input
                type="text"
                value={recipientName}
                onChange={(e) => setRecipientName(e.target.value)}
                placeholder={translations.deliveryPage.RecipientName}
                className="delivery-input"
            />
            <input
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder={translations.deliveryPage.PhoneNumber}
                className="delivery-input"
            />

            <select
                value={selectedOrgId}
                onChange={(e) => setSelectedOrgId(e.target.value)}
                className="delivery-input"
            >
                <option value="">{translations.deliveryPage.selectRestaurant || 'Select a restaurant'}</option>
                {organizations.map(org => (
                    <option key={org.id} value={org.id}>{org.name}</option>
                ))}
            </select>

            <div className={'address-input-container'}>

                <div className="delivery-time-options">
                    <label className="switch-option">
                        <input
                            type="radio"
                            name="deliveryTime"
                            value="asap"
                            checked={deliveryTimeOption === 'asap'}
                            onChange={handleOptionChange}
                            className="switch-input"
                        />
                        <span className="switch-slider"></span>
                        <span className="switch-text">{translations.deliveryPage.AsSoonAsPossible}</span>
                    </label>

                    <label className="switch-option">
                        <input
                            type="radio"
                            name="deliveryTime"
                            value="scheduled"
                            checked={deliveryTimeOption === 'scheduled'}
                            onChange={handleOptionChange}
                            className="switch-input"
                        />
                        <span className="switch-slider"></span>
                        <span className="switch-text">{translations.deliveryPage.AtScheduledTime}</span>
                    </label>
                </div>

                    {deliveryTimeOption === 'scheduled' && (
                        <div className="datetime-container" style={{marginTop: '15px'}}>
                            <input
                                type="datetime-local"
                                value={deliveryDateTime}
                                onChange={handleDateTimeChange}
                                className="datetime-input"
                                min={new Date().toISOString().slice(0, 16)}
                            />
                        </div>
                    )}
            </div>

            <div className="last-delivery-block">
                {/* Number of Persons Block */}
                <div className="persons-count-container">
                    <div className="DeliveryMethod">{translations.deliveryPage.NumberOfPersons}</div>
                    <div className="counter-control">
                        <button
                            className="counter-btn minus"
                            onClick={() => handlePersonsChange(-1)}
                        >-
                        </button>
                        <span className="counter-value">{personsCount}</span>
                        <button
                            className="counter-btn plus"
                            onClick={() => handlePersonsChange(1)}
                        >+
                        </button>
                    </div>
                </div>

                {/* Comment Block */}
                <div className="comment-container">
                    <div className="DeliveryMethod">{translations.deliveryPage.CommentForTheRestaurant}</div>
                    <textarea
                        className="comment-textarea"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder={translations.deliveryPage.YourWishes}
                    />
                </div>

                <div className="payment-container">
                    <div className="DeliveryMethod">{translations.deliveryPage.PaymentMethod}</div>
                    <div className="payment-options">
                        <label className="payment-option">
                            <input
                                type="radio"
                                name="paymentMethod"
                                value="online"
                                checked={paymentMethod === 'online'}
                                onChange={handlePaymentChange}
                            />
                            <span>{translations.deliveryPage.Online || 'Online'}</span>
                        </label>
                    </div>
                </div>

            <FirebaseOrder
                orderData={{
                    orderType:'self-pickup',
                    recipientName,
                    phoneNumber,
                    destination,
                    selectedOrgId,
                    deliveryTime: deliveryTimeOption === 'asap' ? 'Now' : deliveryDateTime,
                    personsCount,
                    comment,
                    paymentMethod,
                    pickupLocation: pickup
                }}
                selectedProducts={selectedProducts}
                productQuantities={productQuantities}
                totalPrice={totalPrice}
                orderReceipt={orderReceipt}
            />
            </div>

        </div>

    );
};

export default AddSelfTake;
